import { useScreenBreakpoint } from 'consts/breakpoints';
import { useLocale } from 'locale';
import React, { useEffect, useState } from 'react';
import { CompareButton } from './styled';
import Downshift from 'downshift';
import { IAutocompleteEntry, IAutocompleteNeighbourhood } from 'utils/entities';
import { connect } from 'react-redux';
import { navigateTo } from 'store/state/router/actions';
import { NavigateToFn, Route } from 'config/routes';
import { noop } from 'lodash';
import { CompareList } from './CompareList';
import { getMatchedListingsCount } from 'store/state/investors/actions';
import { investorMatchedListingsCountSelector } from 'store/state/domainData/selectors/investors';
import { State } from 'store/state';
import { enhanceList } from './helper';


const CompareTrigger: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useLocale();

  return <CompareButton onClick={onClick}>{t('investors.compare.button')}</CompareButton>;
};

interface ICompareFilterBase {
  items: IAutocompleteEntry[];
  navigate: NavigateToFn;
  getListingCount: () => void;
  matchedListings: Array<{
    neighborhoodDocId: string;
    matchedListingsCount: number;
  }>;
}

const CompareFilterBase: React.FC<ICompareFilterBase> = ({ items, navigate, getListingCount, matchedListings }) => {
  const isDesktop = useScreenBreakpoint() >= 3;
  const [ isCompareOpen, setIsCompareOpen ] = useState(false);
  const renderDirectLink = items.length === 2;

  const handleCompareClick = () => {
    navigate(Route.InvestorsNeighbourhoodPage, { id: items[0].docId, compareId: items[1].docId });
  };

  useEffect(() => {
    if (items && items.length >= 3) {
      getListingCount();
    }
  }, [ items, getListingCount ]);

  return isDesktop ? (
      <Downshift
        isOpen={isCompareOpen}
        onOuterClick={renderDirectLink ? noop : () => setIsCompareOpen(false)}
      >
        {({ isOpen }) => {
          return (
            <div style={{ position: 'relative' }}>
              <CompareTrigger onClick={renderDirectLink ? handleCompareClick : () => setIsCompareOpen(!isCompareOpen)} />
              {isOpen ? (
                <div style={{ position: 'absolute', zIndex: 200, right: 0, top: 'calc(100% + 8px)' }}>
                  <CompareList items={enhanceList(items as IAutocompleteNeighbourhood[], matchedListings || [])} navigate={navigate} />
                </div>
              ) : null}
            </div>
          );
        }}
      </Downshift>
  ) : null;
};

const mapStateToProps = (state: State) => ({
  matchedListings: investorMatchedListingsCountSelector(state),
});

const mapDispatchToProps = {
  navigate: navigateTo,
  getListingCount: getMatchedListingsCount,
};

export const CompareFilter = connect(mapStateToProps, mapDispatchToProps)(CompareFilterBase);
